import './DocDownloadFiles.scss';

import React from 'react';
import { Link } from '@tmapy/style-guide';

import { type createDownloadLink } from '../../hooks/useDownloadLink';
import { FileIconWithBadge } from './FileIconWithBadge';

export type DownloadFileItem = {
  permission: boolean;
  link: ReturnType<typeof createDownloadLink> | undefined | null;
  label: React.ReactNode;
  ext?: string;
};

type Props = {
  docId: number | undefined | null;
  items: DownloadFileItem[];
  title?: React.ReactNode;
};

export function DocDownloadFiles({ docId, items, title }: Props) {
  const visible = items.filter((item) => item.permission && item.link);
  if (!docId || visible.length === 0) return null;

  return (
    <>
      {title && <h3 className='sg-u-type-h2 sg-a-ml-2'>{title}</h3>}
      <div className='sg-u-box dmx-docDownloadFiles sg-a-mt-1'>
        {visible.map((item, i) => (
          <div key={i} className='dmx-docDownloadFiles--item'>
            <FileIconWithBadge ext={item.ext} />
            <span className='dmx-docDownloadFiles--name'>
              <Link {...item.link!} severity='colorful' download>
                {item.label}
              </Link>
            </span>
          </div>
        ))}
      </div>
    </>
  );
}
